module.exports = __webpack_public_path__ + "static/media/ev1.d1c50afe.jpg";